/* Udyan 1 Oct: Kettle Talk blog behaviour (sections/ut-blog, sections/ut-article). No dependencies.
   Landing: topic filter, search, "Load more", ?topic= in the URL. Article: reading bar (progress, minutes left,
   title), contents rail + sheet, "At a glance" placement, product strip (adds to the theme cart drawer),
   steep timer, copy link, comments panel. Sticky bars sit under the theme header when it slides back in. */
(function () {
  'use strict';

  var root = document.querySelector('.ut-kt');
  if (!root || window.utKettleTalk) return;
  window.utKettleTalk = true;

  var desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Sticky offset: follow Dawn's "on scroll up" header ---------- */
  var header = document.querySelector('.section-header');
  function headerOffset() {
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  var lastTop = -1;
  function syncTop() {
    var t = headerOffset();
    if (t !== lastTop) {
      lastTop = t;
      document.querySelectorAll('.ut-kt').forEach(function (el) {
        el.style.setProperty('--kt-top', t + 'px');
      });
    }
  }

  var ticking = false;
  var onScrollFns = [syncTop];
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      onScrollFns.forEach(function (fn) {
        fn();
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Dawn slides the header in and out with a CSS transition after the scroll event: check again when it settles.
  var settle = null;
  window.addEventListener(
    'scroll',
    function () {
      clearTimeout(settle);
      settle = setTimeout(syncTop, 320);
    },
    { passive: true }
  );
  if (header) header.addEventListener('transitionend', syncTop);

  /* ---------- Landing ---------- */
  var landing = document.querySelector('[data-kt-landing]');
  if (landing) initLanding(landing);

  function initLanding(el) {
    var filter = el.querySelector('[data-kt-filter]');
    var topicBtns = Array.prototype.slice.call(el.querySelectorAll('[data-kt-topic-btn]'));
    var input = el.querySelector('[data-kt-search]');
    var toggle = el.querySelector('[data-kt-search-toggle]');
    var items = Array.prototype.slice.call(el.querySelectorAll('.kt-grid__item'));
    var label = el.querySelector('[data-kt-grid-label]');
    var empty = el.querySelector('[data-kt-empty]');
    var emptyQ = el.querySelector('[data-kt-empty-q]');
    var more = el.querySelector('[data-kt-more]');
    var count = el.querySelector('[data-kt-count]');
    var loadMore = el.querySelector('[data-kt-load-more]');
    var browseOnly = Array.prototype.slice.call(el.querySelectorAll('[data-kt-browse]'));
    var list = el.querySelector('[data-kt-list]');

    function pageSize() {
      return parseInt(desktop.matches ? el.dataset.pageDesktop : el.dataset.pageMobile, 10) || 9;
    }

    var params = new URLSearchParams(window.location.search);
    var state = { topic: '', query: '', limit: pageSize() };
    var wanted = (params.get('topic') || '').toLowerCase();
    if (wanted && topicBtns.some(function (b) { return b.dataset.ktTopicBtn === wanted; })) state.topic = wanted;
    if (params.get('q')) {
      state.query = params.get('q');
      input.value = state.query;
      filter.classList.add('is-search-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (it) {
      it.removeAttribute('data-kt-late');
    });

    function render() {
      var q = state.query.trim().toLowerCase();
      var browsing = !state.topic && !q;
      var matches = items.filter(function (it) {
        var card = it.querySelector('[data-kt-card]');
        if (browsing && it.hasAttribute('data-kt-feat')) return false;
        if (state.topic && card.dataset.ktTopic !== state.topic) return false;
        if (q && card.dataset.ktText.indexOf(q) === -1) return false;
        return true;
      });
      items.forEach(function (it) {
        it.hidden = true;
      });
      matches.slice(0, state.limit).forEach(function (it) {
        it.hidden = false;
      });
      // The featured card is hidden by CSS until JS decides; once filtering it is a normal card.
      items.forEach(function (it) {
        if (it.hasAttribute('data-kt-feat')) it.style.display = it.hidden ? '' : 'block';
      });

      browseOnly.forEach(function (b) {
        b.hidden = !browsing;
      });

      topicBtns.forEach(function (b) {
        var on = b.dataset.ktTopicBtn === state.topic;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var activeBtn = topicBtns.filter(function (b) { return b.dataset.ktTopicBtn === state.topic; })[0];
      label.textContent = q ? 'Search results' : state.topic && activeBtn ? activeBtn.dataset.ktLabel : label.dataset.default;

      empty.hidden = matches.length > 0;
      emptyQ.textContent = state.query.trim() || (activeBtn ? activeBtn.dataset.ktLabel : '');
      var shown = Math.min(state.limit, matches.length);
      more.hidden = matches.length <= state.limit;
      count.textContent = 'Showing ' + shown + ' of ' + matches.length + ' stories';

      var p = new URLSearchParams(window.location.search);
      if (state.topic) p.set('topic', state.topic); else p.delete('topic');
      if (q) p.set('q', state.query.trim()); else p.delete('q');
      var qs = p.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }

    function scrollToList() {
      var top = list.getBoundingClientRect().top;
      var bar = filter.getBoundingClientRect().bottom;
      if (top < bar) {
        window.scrollTo({ top: window.scrollY + top - bar - 10, behavior: 'smooth' });
      }
    }

    topicBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.topic = b.dataset.ktTopicBtn;
        state.limit = pageSize();
        render();
        scrollToList();
        b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });

    input.addEventListener('input', function () {
      state.query = input.value;
      state.limit = pageSize();
      render();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.blur();
        scrollToList();
      }
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = !filter.classList.contains('is-search-open');
        filter.classList.toggle('is-search-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          input.focus();
        } else if (state.query) {
          input.value = '';
          state.query = '';
          state.limit = pageSize();
          render();
        }
      });
    }

    el.querySelector('[data-kt-clear]').addEventListener('click', function () {
      state.topic = '';
      state.query = '';
      input.value = '';
      state.limit = pageSize();
      render();
      input.focus();
    });

    loadMore.addEventListener('click', function () {
      var before = state.limit;
      state.limit += pageSize();
      render();
      var next = items.filter(function (it) { return !it.hidden; })[before];
      var link = next && next.querySelector('a');
      if (link) link.focus({ preventScroll: true });
    });

    render();
  }

  /* ---------- Article ---------- */
  var article = document.querySelector('[data-kt-article]');
  if (article) initArticle(article);

  function slug(text) {
    return (
      'kt-' +
      text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 60)
    );
  }

  function initArticle(el) {
    var rbar = el.querySelector('[data-kt-rbar]');
    var bar = el.querySelector('[data-kt-progress]');
    var left = el.querySelector('[data-kt-left]');
    var h1 = el.querySelector('[data-kt-h1]');
    var main = el.querySelector('[data-kt-main]');
    var prose = el.querySelector('[data-kt-prose]');
    var grid = el.querySelector('.kt-body__grid');
    var mins = parseInt(el.dataset.mins, 10) || 1;

    /* Lead paragraph: the opening paragraph reads larger, as in the design. */
    var opening = Array.prototype.filter.call(prose.children, function (n) {
      return n.textContent.trim().length > 0 && !n.hasAttribute('data-kt-slot');
    })[0];
    if (opening && opening.tagName === 'P' && opening.textContent.trim().length > 40) opening.classList.add('kt-lede');

    /* Links to other websites open in a new tab, so the reader keeps their place in the story. */
    prose.querySelectorAll('a[href]').forEach(function (a) {
      if (!/^https?:$/.test(a.protocol)) return;
      var host = a.hostname.replace(/^www\./, '');
      if (host === location.hostname.replace(/^www\./, '') || /(^|\.)udyantea\.com$/.test(host)) return;
      a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['noopener', 'noreferrer'].forEach(function (r) {
        if (rel.indexOf(r) === -1) rel.push(r);
      });
      a.setAttribute('rel', rel.join(' '));
      if (!a.querySelector('.visually-hidden')) {
        var note = document.createElement('span');
        note.className = 'visually-hidden';
        note.textContent = ' (opens in a new tab)';
        a.appendChild(note);
      }
    });

    /* At a glance (phones and tablets): into its slot, or before the first heading. */
    var glance = el.querySelector('[data-kt-glance-inline]');
    if (glance) {
      var slot = prose.querySelector('[data-kt-slot="glance"]');
      var firstH2 = prose.querySelector('h2');
      if (slot) slot.parentNode.replaceChild(glance, slot);
      else if (firstH2) firstH2.parentNode.insertBefore(glance, firstH2);
      else prose.appendChild(glance);
    }

    /* Product strips: move each into its marker; unused ones stay hidden. */
    var strips = el.querySelector('[data-kt-strips]');
    if (strips) {
      prose.querySelectorAll('[data-kt-product]').forEach(function (m) {
        var s = strips.querySelector('[data-kt-strip="' + m.getAttribute('data-kt-product') + '"]');
        if (s) m.parentNode.replaceChild(s, m);
      });
    }
    el.querySelectorAll('[data-kt-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn);
      });
    });

    /* Steep timers */
    prose.querySelectorAll('[data-kt-timer]').forEach(initTimer);

    /* Contents: Introduction + every h2 */
    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
    var entries = [];
    if (heads.length >= 2) {
      var step = 0;
      prose.id = prose.id || 'kt-intro';
      entries.push({ id: prose.id, num: '', label: 'Introduction', el: prose });
      heads.forEach(function (h) {
        if (!h.id) h.id = slug(h.textContent);
        var num = '';
        if (h.classList.contains('kt-step')) {
          step += 1;
          num = (step < 10 ? '0' : '') + step;
        }
        entries.push({ id: h.id, num: num, label: h.textContent.trim(), el: h });
      });
    }
    var tocLinks = [];
    if (entries.length) {
      var toc = el.querySelector('[data-kt-toc]');
      var tocList = el.querySelector('[data-kt-toc-list]');
      var sheetList = el.querySelector('[data-kt-sheet-list]');
      entries.forEach(function (e) {
        [tocList, sheetList].forEach(function (listEl, i) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'kt-toc__link';
          a.href = '#' + e.id;
          a.innerHTML = '<span class="kt-toc__num"></span><span></span>';
          a.firstChild.textContent = e.num;
          a.lastChild.textContent = e.label;
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (i === 1) closeSheet(true);
            var top = e.el.getBoundingClientRect().top;
            var off = rbar.offsetHeight + 20 + (top < 0 && header ? header.offsetHeight : 0);
            window.scrollTo({ top: top + window.scrollY - off - (e.el === prose ? 20 : 0), behavior: 'smooth' });
            history.replaceState(null, '', '#' + e.id);
          });
          li.appendChild(a);
          listEl.appendChild(li);
          tocLinks.push({ a: a, id: e.id });
        });
      });
      toc.hidden = false;
      grid.classList.add('has-toc');
      el.querySelector('[data-kt-sheet-open]').hidden = false;
    }

    /* Sheet */
    var sheet = el.querySelector('[data-kt-sheet]');
    var opener = el.querySelector('[data-kt-sheet-open]');
    function openSheet() {
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var active = sheet.querySelector('.kt-toc__link.is-active') || sheet.querySelector('.kt-sheet__close');
      active.focus();
    }
    function closeSheet(silent) {
      if (sheet.hidden) return;
      sheet.hidden = true;
      document.documentElement.style.overflow = '';
      if (!silent) opener.focus();
    }
    opener.addEventListener('click', openSheet);
    sheet.querySelectorAll('[data-kt-sheet-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        closeSheet();
      });
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
      if (e.key === 'Tab') {
        var f = sheet.querySelectorAll('a, button:not([tabindex="-1"])');
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* Reading progress, minutes left, title in the bar, active contents entry */
    function onRead() {
      var r = main.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = r.height - vh * 0.6;
      var p = Math.min(1, Math.max(0, (160 - r.top) / Math.max(1, total)));
      bar.style.width = (p * 100).toFixed(1) + '%';
      var rest = Math.max(0, Math.ceil(mins * (1 - p)));
      left.textContent = p >= 0.98 ? 'Finished' : p < 0.02 ? mins + ' min read' : rest + ' min left';
      rbar.classList.toggle('is-past-title', h1.getBoundingClientRect().bottom < rbar.getBoundingClientRect().bottom);

      if (entries.length) {
        var line = rbar.getBoundingClientRect().bottom + 90;
        var active = entries[0].id;
        entries.forEach(function (e) {
          if (e.el !== prose && e.el.getBoundingClientRect().top < line) active = e.id;
        });
        tocLinks.forEach(function (t) {
          var on = t.id === active;
          t.a.classList.toggle('is-active', on);
          if (on) t.a.setAttribute('aria-current', 'true');
          else t.a.removeAttribute('aria-current');
        });
      }
    }
    onScrollFns.push(onRead);

    /* Copy link */
    var copy = el.querySelector('[data-kt-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var url = copy.getAttribute('data-kt-copy');
        var done = function () {
          var lab = copy.querySelector('[data-kt-copy-label]');
          lab.textContent = desktop.matches ? 'Link copied' : 'Copied';
          copy.classList.add('is-done');
          setTimeout(function () {
            lab.textContent = 'Copy link';
            copy.classList.remove('is-done');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try {
            document.execCommand('copy');
          } catch (err) {}
          document.body.removeChild(t);
          done();
        }
      });
    }

    /* Native share sheet (phones: Instagram and other apps) replaces the email button where supported */
    var native = el.querySelector('[data-kt-native-share]');
    if (native && navigator.share) {
      native.hidden = false;
      var mail = el.querySelector('[data-kt-email-share]');
      if (mail) mail.hidden = true;
      native.addEventListener('click', function () {
        navigator.share({ title: native.dataset.title, url: native.dataset.url }).catch(function () {});
      });
    }

    /* Comments panel */
    var cmtToggle = el.querySelector('[data-kt-cmt-toggle]');
    if (cmtToggle) {
      var panel = el.querySelector('[data-kt-cmt-panel]');
      var setOpen = function (open) {
        panel.hidden = !open;
        cmtToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      cmtToggle.addEventListener('click', function () {
        setOpen(panel.hidden);
      });
      var hash = window.location.hash;
      if (panel.querySelector('[data-kt-cmt-open]') || hash === '#comments' || /^#(Comments-|\d)/.test(hash) || /[?&]page=/.test(window.location.search)) {
        setOpen(true);
      }
    }

    syncTop();
    onRead();
  }

  /* ---------- Add to cart (same request as the theme's product-form.js) ---------- */
  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-kt-add'));
    fd.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.setAttribute('aria-busy', 'true');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          alert(res.description || res.message || 'Could not add to cart.');
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: res });
        }
        cart.renderContents(res);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.classList.remove('is-added');
        }, 2500);
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- Steep timer ---------- */
  function initTimer(box) {
    var total = parseInt(box.getAttribute('data-seconds'), 10) || 300;
    var secs = total;
    var tick = null;
    box.classList.add('kt-timer');
    box.innerHTML =
      '<div class="kt-timer__main"><span class="kt-timer__label"></span>' +
      '<span class="kt-timer__time" role="timer" aria-live="off"></span>' +
      '<div class="kt-timer__bar" aria-hidden="true"><span></span></div></div>' +
      '<div class="kt-timer__btns"><button type="button" class="kt-timer__go"></button>' +
      '<button type="button" class="kt-timer__reset">Reset</button></div>' +
      '<span class="kt-visually-hidden" role="status" aria-live="polite"></span>';
    box.querySelector('.kt-timer__label').textContent = box.getAttribute('data-label') || 'Steep timer';
    var time = box.querySelector('.kt-timer__time');
    var fill = box.querySelector('.kt-timer__bar span');
    var go = box.querySelector('.kt-timer__go');
    var reset = box.querySelector('.kt-timer__reset');
    var status = box.querySelector('[role="status"]');

    function draw() {
      var m = Math.floor(secs / 60);
      var s = secs % 60;
      time.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      fill.style.width = ((1 - secs / total) * 100).toFixed(1) + '%';
      go.textContent = tick ? 'Pause' : secs === 0 ? 'Steep again' : secs === total ? 'Start steeping' : 'Resume';
    }
    function stop() {
      clearInterval(tick);
      tick = null;
    }
    go.addEventListener('click', function () {
      if (tick) {
        stop();
        draw();
        return;
      }
      if (secs === 0) secs = total;
      status.textContent = '';
      tick = setInterval(function () {
        secs = Math.max(0, secs - 1);
        if (secs === 0) {
          stop();
          status.textContent = 'Time is up. Your tea is ready.';
          if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
        }
        draw();
      }, 1000);
      draw();
    });
    reset.addEventListener('click', function () {
      stop();
      secs = total;
      status.textContent = '';
      draw();
    });
    draw();
  }

  syncTop();
})();
